<!-- ANGULAR 12 MIGRATED COMPONENT -->
@if (!showConfirmation) {

  <!-- Standard Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <form name="deleteCbcDataForm" novalidate>
      <div class="panel panel-default" style="margin-top:12px">
        <div class="panel-body">
          <div class="form-group">
            <div class="form-row description-row">
              <div class="description">
                GTW Trial Balance data uploaded as part of the Tax Compliance process is leveraged for computing Table 1 by Category.
                The autopopulation of Trial Balance data can be disabled and completely cleared through the Clear Trial Balance Data.
                Clearing Trial Balance data does not impact any modules used for Tax Compliance nor data linked to these modules.
              </div>
            </div>

            <div class="form-row">
              <div class="col-label">
                <label class="form-label">ME Code</label>
              </div>
              <div class="col-value">
                <span>{{ rowData?.MAINTENANCE_OWNER }}</span>
                @if (rowData?.MAINTENANCE_OWNER_DESC) {
<span> - {{ rowData?.MAINTENANCE_OWNER_DESC }}</span>
}
              </div>
            </div>

            <div class="form-row">
              <div class="col-label">
                <label for="clear-trial-bal">Clear Trial Balance Data</label>
              </div>
              <div class="col-checkbox">
                <input id="clear-trial-bal"
                       type="checkbox"
                       class="form-control-checkbox"
                       name="clearTrialBalance"
                       [(ngModel)]="clearTrialBalance">
              </div>
              <div class="col-description description">
                To disable Trial Balance data from showing or refreshing in Table 1: click on Clear Trial Balance data to clear the
                Table 1 grid and after saving, check the TB Lock box on the Business/ME Data Refresh Lock grid. This action will
                prevent any future autopopulation of Trial Balance data.
                <span class="emphasis">
                  This is the preferred method when CbC data will be uploaded through Manual CbCR Adjustments only.
                </span>
              </div>
            </div>

            <div class="form-row">
              <div class="col-label">
                <label for="clear-manual-adj">Clear Manual CbCR Adjustments Data</label>
              </div>
              <div class="col-checkbox">
                <input id="clear-manual-adj"
                       type="checkbox"
                       class="form-control-checkbox"
                       name="clearManualAdj"
                       [(ngModel)]="clearManualAdj">
              </div>
              <div class="col-description description">
                Clearing Manual Adjustments data will permanently remove any manual adjustments that have been made and cannot be
                restored.
              </div>
            </div>

            <div class="form-row">
              <div class="col-label"></div>
              <div class="col-checkbox"></div>
              <div class="col-description description">
                Either of these actions will only impact this ME.
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Standard Footer -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button"
            type="button"
            [disabled]="isDeleteDisabled"
            (click)="save()">
      @if (deleting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
    <button class="cancel-button"
            type="button"
            (click)="cancel()">Cancel</button>
  </div>

}

<!-- Confirmation modal shown after Save click -->
@if (showConfirmation) {
<div class="modal-content">
  <gtw-confirmation-modal
    [config]="confirmConfig"
    [visible]="false"
    (confirmed)="onConfirm()"
    (cancelled)="onCancelConfirm()"
    (closed)="onCancelConfirm()">
  </gtw-confirmation-modal>
</div>
}
